import { type } from '_u/helper'
import Vue from 'vue'
import { CellInput, CellSelect, CellInputNumber, CellDatePicker, CellSwitch } from "ivux"

// 超链接
export function anchorCell(options) {
    options = Object.assign({
        compile: function (row, column, index) {
            return row[column.key]
        }
    }, options)

    return function (h, data) {
        var { row, column, index } = data

        return h("span", {
            domProps: {
                innerHTML: options.compile.call(this, row, column, index)
            },
            class: {
                "grid-cell-link": true
            },
            on: {
                'click': function (e) {
                    e.preventDefault()
                    e.stopPropagation()

                    if (options.click) {
                        options.click.call(e.target, row, column, index)
                    }
                }
            }
        })
    }
}

// 简单的map映射，支持数组或者map对象
export function mapCell(map) {
    return function (h, data) {
        var { row, column, index } = data

        var key = row[column.key],
            value = key,
            color = '', // 字体颜色
            bgColor = '', // 背景颜色
            keys

        // 支持“，”分隔的ids
        if (type(key) == "string") {
            keys = key ? key.split(",") : []
        } else {
            keys = [key]
        }

        // 支持option list
        if (type(map) == "array") {
            let valueArr = []
            keys.forEach(k => {
                var option = map.find(v => v.id == k) || {},
                    meta = option.meta

                // 词典会将备注作为元数据
                if (option.remark) {
                    meta = JSON.safeParse(option.remark)
                }

                // 支持读取颜色，如果有多个则以最后的option为主
                if (meta) {
                    color = meta.color
                }

                valueArr.push(option ? option.text : k)
            })
            value = valueArr.join(",")
        }

        // 支持 nameMap
        if (type(map) == "object") {
            let valueArr = []
            keys.forEach(k => {
                valueArr.push(map[k] ? map[k] : k)
            })
            value = valueArr.join(",")
        }

        var style = {}

        if (color) {
            style.color = color
        }

        return h("span", {
            style,
        }, value)
    }
}

// 支持全局filter的管道操作
export function pipeCell(formatter) {
    return function (h, data) {
        var { row, column, index } = data
        var value = row[column.key]
        var text = formatter.trim().split("|")
            .reduce((acc, part) => {
                var matchs = /^(\w*)(?:\((.*)\))?$/.exec(part)
                var filter = Vue.options.filters[matchs[1].trim()]

                if (filter) {
                    // 目前参数只支持字符串
                    var params = matchs[2] ? matchs[2].split(",") : []

                    return filter.apply(null, [acc, ...params])
                }

                return acc
            }, value)

        return h("span", {
            // class: {
            //  "svu-single-line": true
            // }
        }, text)
    }
}

// 编辑组件
const cellEdits = {
    CellInput,
    CellSelect,
    CellInputNumber,
    CellDatePicker,
    CellSwitch,
}

export function editCell(name, options = {}) {
    return function (h, data) {
        var { props, attrs, on } = options

        return h(cellEdits[name], {
            props: Object.assign({}, data, props),
            attrs,
            on
        })
    }
}
